import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Drawer, List, ListItem, Typography, FormControlLabel, Checkbox, IconButton } from '@material-ui/core';
import { KeyboardArrowLeft } from '@material-ui/icons';

import { setCalendarOption, setIsCalendarSelected, setIsMapSelected } from 'pages/Scheduling/store/actions';
import { persistQueryParamsSearch } from 'components/Filter/store/actions';

import useDidMount from 'helpers/hooks/useDidMount';

const Logo = require('../../assets/img/logo_jump.svg');
const Calendar = require('../../assets/img/icon-scheduling-calendar.svg');
const Day = require('../../assets/img/icon-scheduling-day.svg');
const Week = require('../../assets/img/icon-scheduling-week.svg');
const Month = require('../../assets/img/icon-scheduling-month.svg');
const Map = require('../../assets/img/icon-scheduling-map.svg');
const Config = require('../../assets/img/icon-scheduling-config.svg');

const mobileText = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px'
}

const mobileListBorderBottom = {
  borderBottom: '1px solid #D7D7D7'
}

const mobileListBorderTop = {
  borderTop: '1px solid #D7D7D7'
}

export default function SchedulingMobileMenu({ isOpen, onClose, setIsCalendar, setIsMap }) {
  const dispatch = useDispatch();

  const history = useHistory();

  const didComponentMount = useDidMount();

  const { qp } = useSelector(state => state.filters);

  const [isServices, setIsServices] = useState(qp?.includes('typeId=1'));
  const [isOthers, setIsOthers] = useState(qp?.includes('typeId=2'));

  useEffect(() => {
    if(!didComponentMount) {
      if(isServices) {
        dispatch(persistQueryParamsSearch('&typeId=1'));
      }

      if(isOthers) {
        dispatch(persistQueryParamsSearch('&typeId=2'));
      }

      if(!isServices && !isOthers) {
        dispatch(persistQueryParamsSearch(''));
      }

      setTimeout(() => onClose(), 500);
    }
  }, [isServices, isOthers]);

  return(
    <Drawer
      id='scheduling-mobile-menu'
      anchor='left'
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: {
          width: 350
        }
      }}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: 5 }}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={Logo} width='120' style={{ marginLeft: 15 }} />
            <IconButton onClick={onClose}>
              <KeyboardArrowLeft fontSize='large' />
            </IconButton>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <List component='div'>
              <ListItem
                button
                onClick={() => {
                  dispatch(setIsCalendarSelected(true));
                  dispatch(setIsMapSelected(false));
                  setIsCalendar(true);
                  setIsMap(false);
                  onClose();
                }}
                style={mobileListBorderBottom}
              >
                <div style={mobileText}>
                  <img src={Calendar} width='20' height='20' />
                  <Typography color='primary' variant='h6'>
                    Agenda
                  </Typography>
                </div>
              </ListItem>
            </List>
            <List component='div'>
              <ListItem
                button
                onClick={() => {
                  dispatch(setIsCalendarSelected(true));
                  dispatch(setIsMapSelected(false));
                  setIsCalendar(true);
                  setIsMap(false);
                  onClose();
                  dispatch(setCalendarOption('timeGridDay'));
                }}
                style={mobileListBorderBottom}
              >
                <div style={mobileText}>
                  <img src={Day} width='20' height='20' />
                  <Typography color='primary' variant='h6'>
                    Dia
                  </Typography>
                </div>
              </ListItem>
            </List>
            <List component='div'>
              <ListItem
                button
                onClick={() => {
                  dispatch(setIsCalendarSelected(true));
                  dispatch(setIsMapSelected(false));
                  setIsCalendar(true);
                  setIsMap(false);
                  onClose();
                  dispatch(setCalendarOption('timeGridWeek'));
                }}
                style={mobileListBorderBottom}
              >
                <div style={mobileText}>
                  <img src={Week} width='20' height='20' />
                  <Typography color='primary' variant='h6'>
                    Semana
                  </Typography>
                </div>
              </ListItem>
            </List>
            <List component='div'>
              <ListItem
                button
                onClick={() => {
                  dispatch(setIsCalendarSelected(true));
                  dispatch(setIsMapSelected(false));
                  setIsCalendar(true);
                  setIsMap(false);
                  onClose();
                  dispatch(setCalendarOption('dayGridMonth'));
                }}
                style={mobileListBorderBottom}
              >
                <div style={mobileText}>
                  <img src={Month} width='20' height='20' />
                  <Typography color='primary' variant='h6'>
                    Mês
                  </Typography>
                </div>
              </ListItem>
            </List>
            <List component='div'>
              <ListItem
                button
                onClick={() => {
                  dispatch(setIsCalendarSelected(false));
                  dispatch(setIsMapSelected(true));
                  setIsCalendar(false);
                  setIsMap(true);
                  onClose();
                }}
                style={mobileListBorderBottom}
              >
                <div style={mobileText}>
                  <img src={Map} width='20' height='20' />
                  <Typography color='primary' variant='h6'>
                    Mapa
                  </Typography>
                </div>
              </ListItem>
            </List>
          </div>
          <div style={{ marginTop: 20, marginLeft: 15 }}>
            <Typography color='textSecondary'>
              Tipo de agendamento
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>
              <FormControlLabel
                labelPlacement='end'
                label={
                  <Typography color='primary'>
                    Serviços
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={isServices}
                    onChange={event => {
                      setIsServices(event.target.checked);
                      setIsOthers(false);
                    }}
                  />
                }
              />
              <FormControlLabel
                labelPlacement='end'
                label={
                  <Typography color='primary'>
                    Outros
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={isOthers}
                    onChange={event => {
                      setIsServices(false);
                      setIsOthers(event.target.checked);
                    }}
                  />
                }
              />
            </div>
          </div>
        </div>
        <List component='div'>
          <ListItem
            button
            onClick={() => history.push('/configuracao-agendamento')}
            style={mobileListBorderTop}
          >
            <div style={mobileText}>
              <img src={Config} width='20' height='20' />
              <Typography color='primary' variant='h6'>
                Configurações
              </Typography>
            </div>
          </ListItem>
        </List>
      </div>
    </Drawer>
  )
}